import * as styles from './terms.style.js';
import { cx } from '@emotion/css';

export default function Terms() {
  return (
    <main className={cx(styles.main)}>
      <section className="">
        <h1>Terms of Service</h1>
        <h2>Effective Date: Jan 1, 2022; Last Updated: September 21, 2022</h2>

        <p>
          The "<strong>QuizWizard</strong>" website and its
          applications are a hosted service. Any use of the Service is subject to the
          following Terms and Conditions of Service ("
          <strong>Terms of Service</strong>" or "<strong>Terms</strong>"), as
          well as to <a href="/privacy">QuizWizard's Privacy Policy</a>, all of which are
          incorporated by reference into these Terms of Service. Your use of the
          Service will constitute your acceptance of these Terms of Service.
        </p>
        <ol>
          <li>
            <strong>Eligibility.</strong> Use of the Service is void where
            prohibited. The Service is intended for users over the age of 13,
            but is open to all ages. For children age 13 or younger (or other
            age of consent where required by local law), QuizWizard offers a
            restricted feature set and website experience that removes certain
            features. By using the Service, you represent and warrant that (a)
            all registration information you submit is truthful and accurate;
            (b) you will maintain the accuracy of such information; and (c) your
            use of the Service does not violate any applicable law or
            regulation.
          </li>

          <li>
            <strong>Your QuizWizard Account and Data.</strong> If you create an
            account on the Service, you are responsible for maintaining the
            security of your account and data, and you are fully responsible for
            all activities that occur under the account. Accounts are for
            individual, not organizational, use by a single person only. You may
            not share your account with any other person. You must notify
            QuizWizard immediately of any unauthorized uses of your data, your
            account or any other breaches of security. QuizWizard will not be
            liable for any acts or omissions by you, including any damages of
            any kind incurred as a result of such acts or omissions. QuizWizard may
            from time to time set storage limits for your data, or take any
            other measures it considers appropriate to manage the Service.
            QuizWizard may also from time to time change its policies on offering
            commercial content or displaying advertising, and may do this
            without notice.
          </li>




          <li>
            <strong>Responsibility of Contributors.</strong> If you create challenges,
            batches, new quizzes, or otherwise make material available by means
            of the Service (referred to collectively as "
            <strong>Content</strong>") you are entirely responsible for the
            composition of, and any harm resulting from, that Content. That is
            the case, regardless of whether the Content in question constitutes
            text, graphics, audio files, computer software or any other format
            in which QuizWizard stores data.
          </li>
          <li>
            <strong>Prohibited Content.</strong> You may post only educational
            and study-related Content to the Service. The following are examples
            of Content prohibited to post on or through the Service. QuizWizard
            reserves the right to investigate and take appropriate legal action
            against anyone who, in QuizWizard's sole discretion, violates this
            provision, including without limitation, removing the offending
            Content from the Service, limiting the use of any portion of the
            Service or terminating the accounts of such violators, or seeking
            other legal remedies. Prohibited Content includes, but is not
            limited to, Content that, in the sole discretion of QuizWizard:
            <ul>
              <li>
                is patently offensive and promotes racism, bigotry, hatred or
                physical harm of any kind against any class or individual;
              </li>
              <li>harasses or advocates harassment of another person;</li>
              <li>exploits people in a sexual or violent manner;</li>
              <li>
                contains sexually suggestive, excessively violent, or offensive
                subject matter;
              </li>
              <li>
                solicits personal information from anyone under 18 years old;
              </li>
              <li>
                publicly posts information that poses or creates a privacy or
                security risk to any person;
              </li>
              <li>
                includes information about another person that you have posted
                without that person's consent;
              </li>
              <li>
                violates the privacy rights, publicity rights, copyrights,
                trademark rights, contract rights or any other rights of any
                person;
              </li>
              <li>
                contains or promotes information that you know is false or
                misleading, or promotes illegal activities or conduct that are
                abusive, threatening, obscene, defamatory or libelous;
              </li>
              <li>
                contains or promotes an illegal or unauthorized copy of another
                person's copyrighted work;
              </li>
              <li>
                solicits passwords or personally-identifying information for
                commercial or unlawful purposes from other users;{' '}
              </li>
              <li>
                involves the transmission of junk mail, chain letters,
                unsolicited mass mailings or instant messages, or spam;
              </li>
              <li>
                furthers or promotes any criminal activity or enterprise, or
                provides instructional information about illegal activities
                including, but not limited to, making or buying illegal weapons,
                violating someone's privacy, or providing or creating computer
                viruses;{' '}
              </li>
              <li>
                involves commercial activities and/or sales without prior
                written consent from QuizWizard, such as contests, sweepstakes,
                bartering, advertising, or pyramid schemes;
              </li>
              <li>violates any and all applicable laws or regulations.</li>
            </ul>
          </li>

          <li>
            <strong>Prohibited Activities.</strong> You may only engage in
            educational and study-related activities while using the Service.The
            following are examples of the kind of activity that is prohibited on
            the Service. QuizWizard reserves the right to investigate and take
            appropriate legal action against anyone who, in QuizWizard's sole
            discretion, violates this provision, including without limitation,
            terminating your account and/or access to the Service, reporting you
            to appropriate governmental authorities, including law enforcement,
            or seeking other legal remedies. Prohibited activity includes, but
            is not limited to:
            <ul>
              <li>
                criminal or tortious activity, including child pornography,
                fraud, trafficking in obscene material, drug dealing, gambling,
                harassment, stalking, spamming, sending of viruses or other
                harmful files, copyright infringement, patent infringement, or
                theft of trade secrets;{' '}
              </li>
              <li>
                circumventing or modifying, attempting to circumvent or modify,
                or encouraging or assisting any other person in circumventing or
                modifying any security technology or software that is part of
                the Service;
              </li>
              <li>
                impersonating or attempting to impersonate another user, person
                or entity;
              </li>
              <li>
                using the account, username, or password of another user at any
                time, or disclosing your password to any third party, or
                permitting any third party to access your account;
              </li>
              <li>
                using any information obtained from the Service in order to
                harass, abuse, or harm another person or entity, or attempting
                to do so;
              </li>
              <li>
                activity that involves the use of viruses, bots, worms, or any
                other computer code, files or programs that interrupt, destroy
                or limit the functionality of any computer software or hardware,
                or otherwise permit the unauthorized use of, or access to, a
                computer or a computer network;{' '}
              </li>
              <li>
                any automated use of the system, such as, but not limited to,
                using scripts to create or post Content;
              </li>
              <li>
                interfering with, disrupting, or creating an undue burden on the
                Service or the networks or services connected to the Service;
              </li>
              <li>
                displaying an unauthorized commercial advertisement on the
                Service, or accepting payment or anything of value from a third
                party in exchange for your performing any commercial activity
                through the unauthorized or impermissible use of the Service on
                behalf of that party;
              </li>
              <li>
                reproducing, duplicating, copying, selling, reselling, trading,
                or exploiting for any commercial purposes, any portion of, or
                access to, the Content and/or functionality offered through the
                Service, unless you have been specifically allowed to do so in a
                separate agreement;
              </li>
              <li>
                using the Service in a manner inconsistent with any and all
                applicable laws or regulations.
              </li>
            </ul>
          </li>

          <li>
            <strong>Content Representations and Warranties.</strong> By making
            Content available, you represent and warrant that:
            <ul>
              <li>
                the downloading, copying and use of the Content will not
                infringe the proprietary rights, including but not limited to
                the copyright, patent, trademark or trade secret rights, of any
                third party;
              </li>
              <li>
                if your employer has rights to intellectual property you create,
                you have either (i) received permission from your employer to
                post or make available the Content, including but not limited to
                any software, or (ii) secured from your employer a waiver as to
                all rights in or to the Content;
              </li>
              <li>
                you have fully complied with any third-party licenses relating
                to the Content, and have done all things necessary to
                successfully pass through to end users any required terms;
              </li>
              <li>
                the Content does not contain or install any viruses, worms,
                malware, Trojan horses or other harmful or destructive material;
              </li>
              <li>
                the Content is not spam, and does not contain unethical or
                unwanted commercial material designed to drive traffic to third
                party sites, to boost the search engine rankings of third party
                sites, to enable unlawful acts (such as phishing) or to mislead
                recipients as to the source of the material (such as spoofing);
              </li>
              <li>
                the Content is not obscene or libelous, and does not violate the
                privacy or publicity rights of any third party; and
              </li>
              <li>
                you have, in the case of Content that includes computer code,
                accurately categorized and/or described the type, nature, uses
                and effects of the materials, whether requested to do so by
                QuizWizard or otherwise.
              </li>
            </ul>
          </li>

          <li>
            <strong>License.</strong> By submitting Content or any other
            material to QuizWizard for inclusion on the Service or for any other
            purpose, for example posting a assignment/challenge, answering a survey or
            sending QuizWizard an email, you grant QuizWizard a world-wide, perpetual,
            royalty-free license (with right to sublicense) to use, copy,
            reproduce, process, adapt, modify, publish, transmit, display, and
            distribute such Content or material in any and all media or
            distribution methods (existing or subsequently developed).
            additional uses by QuizWizard, or other companies or individuals who
            partner with QuizWizard, may be made with no compensation paid to you
            with respect to the Content that you submit, post, or otherwise make
            available to QuizWizard or through the Service.
          </li>



          <li>
            <strong>Responsibility of Service Users.</strong> QuizWizard has not
            reviewed, and cannot review, all Content posted to the Service, and
            cannot therefore be responsible for that material's content, use or
            effects. By operating the Service, QuizWizard does not represent or
            imply that it endorses the Content posted thereon, or that it
            believes such material to be accurate, useful or non-harmful. You
            are responsible for taking precautions as necessary to protect
            yourself and your computer systems from viruses, worms, Trojan
            horses, and other harmful or destructive material. The Service may
            contain material that is offensive, indecent, or otherwise
            objectionable, as well as Content in which technical, factual, or
            other inaccuracies, typographical mistakes, or other errors may be
            present. The Service may also contain Content that violates or
            infringes the intellectual property and other proprietary rights of
            third parties, or of which the downloading, copying or use may be
            subject to additional terms and conditions, stated or unstated.
            QuizWizard disclaims any responsibility for any harm resulting from
            your use of the Service, or from you downloading the Content posted
            thereon. If you who discover Content or other material in violation
            of these Terms, you are
            encouraged to report the Content to QuizWizard using the reporting
            functions available on the Service.
          </li>

          <li>
            <strong>Content Posted on Other Websites.</strong> We have not
            reviewed, and cannot review, all of the Content, including computer
            software, made available through the websites and webpages to which
            QuizWizard links, and which link to QuizWizard. QuizWizard does not have any
            control over those third party websites and webpages, and is not
            responsible for their content or your use thereof. By linking to a
            third party website or webpage, QuizWizard does not represent or imply
            that it endorses that website or webpage. You are responsible for
            taking precautions as necessary to protect yourself and your
            computer systems from viruses, worms, Trojan horses, and other
            harmful or destructive material. QuizWizard disclaims any
            responsibility for any harm resulting from your use of third party
            websites and webpages.
          </li>

          <li>
            <strong>Copyright Infringement and DMCA Policy.</strong> QuizWizard
            respects the intellectual property rights of others. If you believe
            that material located on or linked to by QuizWizard violates your
            copyright, you are encouraged to notify QuizWizard
            . QuizWizard will respond to all such notices, including by removing
            the infringing Content or disabling all links to the infringing
            Content, as required or appropriate. In the case of a visitor who
            may infringe, once or repeatedly, the copyrights or other
            intellectual property rights of QuizWizard or others, QuizWizard may, in
            its discretion, terminate or deny access to, or use of, the Service.
            In the case of such termination, QuizWizard will be under no obligation
            to provide a refund of any amounts previously paid to QuizWizard by
            that user.
          </li>

          <li>
            <strong>Trademarks.</strong> QuizWizard, QuizWizard.net, QuizWizard Ads, the
            QuizWizard mark and logo, and all other trademarks, service marks,
            graphics and logos used in connection with QuizWizard, or the Service
            are trademarks or registered trademarks of QuizWizard or QuizWizard's
            licensors. Other trademarks, service marks, graphics and logos used
            in connection with the Service may be the trademarks of other third
            parties. Your use of the Service grants you no right or license to
            reproduce or otherwise use any QuizWizard or third-party trademarks.
            Audio files and software may not be sold or redistributed, or
            offered as a service to others.

          </li>

          <li>
            <strong>Changes to the Service and Terms.</strong> The Service,
            including without limitation all content there available, product
            and Subscription features, any and all of QuizWizard’s policies, and
            these Terms of Service, may be changed at the sole discretion of
            QuizWizard without notice. You are bound by any such updates or
            changes, including but not limited to those affecting these Terms of
            Service, and as such, you should periodically review these Terms of
            Service.
          </li>

          <li class="important">
            <strong>
              LIMITATION OF WARRANTIES OF QUIZWIZARD, ITS SUPPLIERS AND ITS
              LICENSORS.
            </strong>{' '}
            EXCEPT AS OTHERWISE EXPRESSLY STATED, ALL CONTENT POSTED TO OR
            AVAILABLE FROM THE SERVICE IS PROVIDED "AS IS", AND QUIZWIZARD, ITS
            SUPPLIERS AND ITS LICENSORS MAKE NO REPRESENTATIONS OR WARRANTIES,
            EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, OR
            NON-INFRINGEMENT OF PROPRIETARY RIGHTS. YOU UNDERSTAND AND AGREE
            THAT YOU DOWNLOAD FROM, OR OTHERWISE OBTAIN CONTENT OR SERVICES
            THROUGH, THE SERVICE AT YOUR OWN DISCRETION AND RISK, AND THAT
            QUIZWIZARD, ITS SUPPLIERS AND ITS LICENSORS WILL HAVE NO LIABILITY OR
            RESPONSIBILITY FOR ANY DAMAGE TO YOUR COMPUTER SYSTEM OR DATA THAT
            RESULTS FROM THE DOWNLOAD SUCH CONTENT OR THE USE OF THE SERVICE.
            SOME JURISDICTIONS MAY NOT ALLOW THE EXCLUSION OF IMPLIED
            WARRANTIES, SO SOME OF THE ABOVE MAY NOT APPLY TO YOU.
          </li>

          <li class="important">
            <strong>
              LIMITATION OF LIABILITY OF QUIZWIZARD, ITS SUPPLIERS AND ITS
              LICENSORS.
            </strong>{' '}
            EXCEPT AS OTHERWISE EXPRESSLY STATED, IN NO CIRCUMSTANCE WILL
            QUIZWIZARD, ITS SUBSIDIARIES, ITS SUPPLIERS OR ITS LICENSORS BE LIABLE
            TO YOU OR ANY OTHER PARTY FOR ANY DIRECT, INDIRECT, SPECIAL,
            CONSEQUENTIAL OR EXEMPLARY DAMAGES, REGARDLESS OF THE BASIS OR
            NATURE OF THE CLAIM, RESULTING FROM ANY USE OF THE SERVICE, OR THE
            CONTENTS THEREOF OR OF ANY HYPERLINKED WEBSITE INCLUDING WITHOUT
            LIMITATION ANY LOST PROFITS, BUSINESS INTERRUPTION, LOSS OF DATA OR
            OTHERWISE, EVEN IF QUIZWIZARD, ITS SUPPLIERS OR ITS LICENSORS WERE
            EXPRESSLY ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. IN NO EVENT
            WILL THE AGGREGATE LIABILITY FOR ANY AND ALL OF YOUR CLAIMS AGAINST
            QUIZWIZARD, ITS SUPPLIERS AND ITS LICENSORS ARISING FROM, OR RELATED
            TO, USE OF THE SERVICE, OR THE CONTENTS THEREOF, OR OF ANY
            HYPERLINKED WEBSITE, EXCEED THE AMOUNTS ACTUALLY PAID BY YOU TO
            QUIZWIZARD DURING THE 12-MONTH PERIOD PRIOR TO THE DATE A CLAIM IS
            MADE. SOME JURISDICTIONS MAY NOT ALLOW THE EXCLUSION OR LIMITATION
            OF LIABILITY FOR CERTAIN INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO
            SOME OF THE ABOVE LIMITATIONS MAY NOT APPLY TO YOU. THE PARTIES
            AGREE THAT THIS SECTION, SECTION 10, REPRESENTS A REASONABLE
            ALLOCATION OF RISK.
          </li>

          <li>
            <strong>Disputes with QuizWizard.</strong> In the case of any dispute
            between you and QuizWizard arising out of or connected to these Terms
            of Service or your use of the Service, the following rules will
            apply.
            <strong>
              {' '}
              PLEASE READ THIS SECTION CAREFULLY – IT MAY SIGNIFICANTLY AFFECT
              YOUR LEGAL RIGHTS, INCLUDING YOUR RIGHT TO FILE A LAWSUIT IN COURT
              AND TO HAVE A JURY HEAR YOUR CLAIMS.
            </strong>
            <ol>
              <li>
                <strong>Binding Arbitration</strong>: Any dispute arising out of
                or relating to these Terms or your use of our Services will be
                settled through binding arbitration, conducted by the American
                Arbitration Association ("<strong>AAA</strong>") and in
                accordance with their Commercial Arbitration Rules. Your
                responsibility to pay any filing, administrative, or arbitrator
                fees will be solely as set forth in the AAA rules. To the extent
                permitted under AAA rules, the arbitrator may award costs, fees,
                and expenses, including reasonable attorney’s fees, to the
                prevailing party. A decision reached by arbitration will be
                final and binding and may be entered as a judgment by any court
                having jurisdiction. You understand that there is no judge or
                jury in arbitration, and that other procedural rights such as
                discovery and appeal are not available in an arbitration.{' '}
                <strong>
                  YOU AND QUIZWIZARD KNOWINGLY AND VOLUNTARILY AGREE TO WAIVE YOUR
                  RESPECTIVE RIGHTS TO A TRIAL BY JUDGE OR JURY AND TO HAVE YOUR
                  CASE HEARD IN A COURT OF LAW
                </strong>
                .
              </li>
              <li>
                <strong>Disputes will be settled on an individual basis</strong>
                :{' '}
                <strong>
                  {' '}
                  YOU AND QUIZWIZARD KNOWINGLY AND VOLUNTARILY AGREE TO WAIVE YOUR
                  RESPECTIVE RIGHTS TO BRING OR PARTICIPATE IN A CLASS,
                  COLLECTIVE, CONSOLIDATED, OR REPRESENTATIVE ACTION OR
                  ARBITRATION
                </strong>
                . Notwithstanding this clause, each party may seek injunctive or
                other equitable relief in a court of competent jurisdiction in
                San Francisco County to protect the party’s intellectual
                property rights pending completion of the arbitration.
              </li>
            </ol>
          </li>



          <li>
            <strong>General Representation and Warranty.</strong> You represent
            and warrant that your use of the Service will be in accordance with{' '}
            <a href="/privacy">QuizWizard's Privacy Policy</a>, with these Terms of
            Service, with any applicable laws and regulations, including without
            limitation any local laws or regulations in your country, state,
            city, or other governmental area, regarding online conduct and
            acceptable content, and including all applicable laws regarding the
            transmission of technical data exported from the United States or
            the country in which you reside, and with any other applicable
            policy or terms and conditions.
          </li>

          <li>
            <strong>Indemnification.</strong> You agree to defend, indemnify and
            hold harmless QuizWizard, its subsidiaries, its contractors, and its
            licensors, and their respective directors, officers, employees and
            agents from and against any and all claims and expenses, including
            attorneys' fees, arising from your use of the Service, including but
            not limited to, any violation of any representation or warranty
            contained in these Terms of Service.
          </li>

          <li>
            <strong>Miscellaneous.</strong> You agree to defend, indemnify and
            hold harmless QuizWizard, its contractors, and its licensors, and their
            respective directors, officers, employees and agents from and
            against any and all claims and expenses, including attorneys' fees,
            arising from your use of the Service, including but not limited to,
            any violation of any representation or warranty contained in these
            Terms of Service.
          </li>

          <li>
            <strong>Severability.</strong> If any part of these Terms of Service
            is held invalid or unenforceable, that part will be construed to
            reflect the drafter’s original intent, and the remaining portions
            will remain in full force and effect.
          </li>

          <li>
            <strong>Non-waiver of Rights.</strong> A waiver by either party of
            any term or condition of these Terms of Service or any breach
            thereof, in any one instance, will not waive such term or condition
            or any subsequent breach thereof.
          </li>

          <li>
            <strong>Assignment.</strong> You may assign your rights under these
            Terms of Service to any party that consents to, and agrees to be
            bound by, its terms. QuizWizard may assign its rights under these Terms
            of Service without condition. These Terms of Service will be binding
            upon and will inure to the benefit of the parties, their successors
            and permitted assigns.
          </li>

          <li>
            <strong>Survival of Terms.</strong> These Terms continue to apply,
            even after you close your account or cease using the Service.
          </li>
        </ol>
      </section>
    </main>
  );
}
